import { Record } from 'immutable';

const EventMenuSearchFilterPaymentStatusRecord = Record({
  inProcess: true,
  unpaid: true,
  paid: true,
  cancelled: false,
});

export class EventMenuSearchFilterPaymentStatus extends EventMenuSearchFilterPaymentStatusRecord {
  inProcess: boolean;
  unpaid: boolean;
  paid: boolean;
  cancelled: boolean;
}


const EventMenuSearchFilterRecord = Record({
  commissionId: null,
  fundingReferenceId: null,
  paymentReferenceId: null,
  startDate: null,
  endDate: null,
  guestName: null,
  eventStatusCompleted: false,
  eventStatusMissingAgency: false,
  eventStatusArchived: false,
  paymentStatus: {
    inProcess: false,
    unpaid: false,
    paid: false,
    cancelled: false,
  },
  includeArchivedEvents: false,
  includeDeletedEvents: false,
  hasPrepayment: false,
  includeCommRetentionEvents: false
});

export class EventMenuSearchFilter extends EventMenuSearchFilterRecord {
  commissionId: string;
  fundingReferenceId: string;
  paymentReferenceId: string;
  hasPrepayment: boolean;
  startDate: string;
  endDate: string;
  guestName: string;
  eventStatusMissingAgency: boolean;
  eventStatusCompleted: boolean;
  eventStatusArchived: boolean;
  includeArchivedEvents: boolean;
  includeDeletedEvents: boolean;
  paymentStatus: EventMenuSearchFilterPaymentStatus;
  includeCommRetentionEvents: boolean;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/event-menu-search-filter.ts